import Vue from 'vue'
import Router from 'vue-router'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import OneClickOrder from './views/item/OneClickOrder.vue'
import Cart from './views/item/Cart.vue'
import Login from './views/login/Login.vue'
// 商品相关
import index from './views/item/index.vue'
import quotation from './views/item/Quotation.vue'
import ItemDetails from './views/item/ItemDetails.vue'
import Promotional from './views/item/Promotional.vue'
// 用户相关
import ChangePassword from './views/user/ChangePassword.vue'

// 订单相关
import AllOrders from './views/order/AllOrders.vue'
import CurrentOrder from './views/order/CurrentOrder.vue'
// 品牌厂家
import Manufacturer from './views/manufacturer/Manufacturer.vue'

// 联盟品种
import UnionItem from './views/union/UnionItem.vue'

//首页
import HomeIndex from './views/home/index3.vue'
//关于我们
import AboutAus from "../src/views/home/aboutAus/index.vue"
//联系我们
import contactUs from "@/views/home/contactUs/index.vue"

//产品详情
import detail from '@/views/home/productDetail/index.vue'

//行业资讯
import news from '@/views/home/news/index.vue'

Vue.use(BootstrapVue)
Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
export default new Router({
  base: process.env.BASE_URL,
  mode: 'history',
  routes: [
    {
      path: '/news',
      component: news
    },
    {
      path: '/productDetail',
      component: detail
    },
    {
      path: '/contactUs',
      component: contactUs
    },
    {
      path: '/about',
      component: AboutAus
    },
    {
      path: '/home',
      component: news
    },
    {
      path: '/',
      redirect: '/home'
    },
    // =============================商品相关
    {
      path: '/index',
      component: index
    },
    {
      path: '/manufacturer',
      component: Manufacturer
    },
    {
      path: '/union',
      component: UnionItem
    },

    {
      path: '/quotation',
      component: quotation
    },
    {
      path: '/promotional',
      component: Promotional
    },
    // =============================用户相关
    {
      path: '/login',
      component: Login
    },
    {
      path: '/item',
      name: 'item',
      component: ItemDetails
    },
    {
      path: '/login',
      beforeEnter(to, from, next) {
        location.replace(process.env.BASE_URL + 'login.html')
      }
    },
    {
      path: 'message',
      beforeEnter(to, from, next) {
        location.replace(process.env.BASE_URL + 'message.html')
      }
    },
    {
      path: '/about'
    },
    {
      path: '/order',
      name: 'purchase',
      component: OneClickOrder
    },
    {
      path: '/orders',
      name: 'orders',
      component: AllOrders
    },
    {
      path: '/myCart',
      name: 'cart',
      component: Cart
    },
    {
      path: '/orderConfirm',
      name: 'orderConfirm',
      component: CurrentOrder
    },
    {
      path: '/changePassword',
      name: 'changePassword',
      component: ChangePassword
    },
    {
      path: '/changePassword',
      beforeEnter(to, from, next) {
        location.replace(process.env.BASE_URL + 'changePassword.html')
      }
    }
  ]
})
